import { TranslateService } from "@ngx-translate/core";
import { MatDialog } from "@angular/material/dialog";
import { CreateAlertComponent } from "./../../create-alert/create-alert.component";
import { Router } from "@angular/router";
import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { OrderBuyComponent } from "../../order-buy/order-buy.component";
import { FavService } from "src/app/services/fav.service";

@Component({
  selector: "app-context-menu",
  templateUrl: "./context-menu.component.html",
  styleUrls: ["./context-menu.component.scss"],
})
export class ContextMenuComponent implements OnInit {
  @Input() x = 0;
  @Input() y = 0;
  @Input() isShow: boolean;
  @Input() item;
  @Output()
  addNew = new EventEmitter<string>();
  @Output() clickedOutside = new EventEmitter();

  constructor(
    private eRef: ElementRef,
    private nav: Router,
    private favService: FavService,
    private matDialog: MatDialog,
    public translate: TranslateService
  ) { }
  @HostListener("document:click", ["$event"])
  clickout(event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.clickedOutside.emit();
    }
  }
  ngOnInit() { }

  orderBuy(isSell) {
    const dialogRef = this.matDialog.open(OrderBuyComponent, {
      disableClose: true,
      panelClass: "order-dialog-container",
      data: { symbol: this.item.symbol, type: isSell },
      direction: this.translate.currentLang == "ar" ? "rtl" : "ltr",
    });

    dialogRef.afterClosed().subscribe((result) => { });
  }

  addWidgett(name) {

    let obj = {
      name: name,
      companyData: this.item,
      isLinked: false
    };
    this.addNew.emit(JSON.stringify(obj));
    this.clickedOutside.emit();
  }

  setAlert() {
    this.clickedOutside.emit();

    const dialogRef = this.matDialog.open(CreateAlertComponent, {
      disableClose: true,
      data: this.item,
      width: "600px",
    });

    dialogRef.afterClosed().subscribe((result) => { });
  }

  navigateProfile() {
    this.nav.navigate([
      "/company-profile",
      this.item.symbol,
      this.item.reuters,
    ]);
  }

  navigateQuota() {
    this.nav.navigate(["/detailed-quota", this.item.symbol]);
  }
  isFav(symbol) {
    return this.favService.isFav(symbol);
  }

  toggleFav(symbol) {
    //this.favService.toggleFav(symbol);
  }
}
